
  <div class="card text-center mx-auto col-12 col-lg-6 shadow">
    <div class="card-body pt-2 pl-1 pr-1">
        <form [formGroup]="datosForm">
        <h5 class="card-title font-bold text-primary">
          Certificados
        </h5>
  
        <div class="card mx-auto mt-4">
            <div class="card-header d-flex align-items-center justify-content-between">
                <div class="">
                  <span class="box-title mr-2">Cuenta: </span>
                  <span class="box-subtitle">{{cuentaSeleccionada?.codigo}}</span>
                </div>
          
                <div class="">
                  <span class="box-title mr-2">Tipo: </span>
                  <span class="box-subtitle">{{cuentaSeleccionada?.tipoCuenta}}</span>
                </div>
              </div>
          </div>
        <div class="form-group border border-ligth rounded p-4 mx-auto mt-2">
            <label class="card-text text-primary font-weight-bold ">
                Tipo de certificado
              </label>
          <select
            #certificadoSelect
            class="form-control"
            id="inputCertificado"
            formControlName="certificado"
            (change)="VerificarCertificado(certificadoSelect.value)"
          >
          <option disabled selected value="" hidden >Seleccione</option>
            <option
              *ngFor="let certificado of certificados"
              [value]="certificado?.secuencial"
            >
             {{ certificado?.nombre }}
            </option>
          </select>
        </div>

        <div *ngIf="seleccionoCertificado" class="mt-2">
          <div
            class="alert alert-secondary d-flex align-items-center mx-auto"
            role="alert"
          >
            <span class="material-icons text-dark mr-2">description</span>
            <div>
              {{"EL documento se enviara al correo"}} <span  class="font-weight-bold">{{usuario?.correo}}</span>, y tiene un costo de
              <span class="font-weight-bold">{{ certificadoSeleccionado.valorDebito| currency }}</span
              >.
            </div>
          </div>
      
          <div class="border border-ligth rounded p-4 mx-auto">
            <label class="card-text text-primary font-weight-bold">
                Cuenta a debitar
              </label>
            <select
              #cuentaSelect
              class="form-control"
              id="inputCuenta"
              formControlName="cuenta"
              (change)="validarSaldo(cuentaSelect.value)"
            >
            <option disabled selected value="" hidden >Seleccione</option>
              <option *ngFor="let cuenta of cuentas" [value]="cuenta?.secuencial">
                {{ cuenta?.codigo }} - {{ cuenta?.tipoCuenta }} -
                {{ cuenta?.saldoDisponible | currency }}
              </option>
            </select>
            <div
            *ngIf="this.errroSaldo != ''"
            class="invalid-feedback"
          >
            {{this.errroSaldo}}
          </div>
          </div>
          <div class="btn-footer mt-2">
            <button
              type="button"
              class="btn btn-primary"
              [disabled]="datosForm.invalid || !activarButton"
              (click)="GenerarCertificado()"
            >
              Solicitar
            </button>
          </div>
        </div>
        </form>
      </div>
    </div>

